"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyCategory = exports.FIAT_SYNTHS = exports.NetworkNameById = exports.NetworkIdByName = void 0;
const synths_1 = require("@synthetixio/contracts/build/mainnet/synths");
const synths_2 = require("@synthetixio/contracts/build/mainnet-ovm/synths");
exports.NetworkIdByName = {
    mainnet: 1,
    goerli: 5,
    'goerli-ovm': 420,
    'mainnet-ovm': 10,
    kovan: 42,
    'kovan-ovm': 69,
    'mainnet-fork': 31337,
};
exports.NetworkNameById = {
    1: 'mainnet',
    5: 'goerli',
    42: 'kovan',
    10: 'mainnet-ovm',
    69: 'kovan-ovm',
    420: 'goerli-ovm',
    31337: 'mainnet-fork',
};
function notNill(value) {
    return value !== null && value !== undefined;
}
const AllSynths = Object.values(synths_1.SynthsByName)
    .concat(Object.values(synths_2.SynthsByName))
    .filter(notNill);
exports.FIAT_SYNTHS = new Set(AllSynths.filter((x) => x.category === 'forex').map((x) => x.name));
var CurrencyCategory;
(function (CurrencyCategory) {
    CurrencyCategory["crypto"] = "Crypto";
    CurrencyCategory["forex"] = "Forex";
    CurrencyCategory["equity"] = "Equity";
    CurrencyCategory["commodity"] = "Commodity";
})(CurrencyCategory = exports.CurrencyCategory || (exports.CurrencyCategory = {}));
